export function parsePointOfContact(vendorContact) {
  if (vendorContact.id) {
    return { id: vendorContact.id };
  }
  if (vendorContact.contact.id) {
    return { ...vendorContact, contact: { id: vendorContact.contact.id } };
  }
  return vendorContact;
}
